var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'a',_vm._b({tag:"component",staticClass:"jdsc-link",attrs:{"target":_vm.newTab ? '_blank' : '_self'}},'component',_vm.linkProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }